import DOMPurify from 'dompurify';
import type { EventGroupAvailability } from '@/types/event';
import { formatGroupTime } from '@/lib/eventGroups';
import { MapPin } from 'lucide-react';

interface EventAgendaProps {
  agenda: string;
  selectedGroup?: EventGroupAvailability | null;
  venue?: string;
  timezone?: string;
}

const EventAgenda = ({ agenda, selectedGroup, venue, timezone }: EventAgendaProps) => {
  if (!agenda) return null;
  
  return (
    <div className="bg-white rounded-lg p-4 shadow-md mb-4">
      <h2 className="font-semibold mb-3">Agenda</h2>
      {selectedGroup && (
        <div className="mb-3 border-b border-border pb-3 text-sm text-foreground">
          <p className="font-medium">{selectedGroup.name} · {formatGroupTime(selectedGroup.start_time, timezone)}</p>
          <p className="mt-1 flex items-start gap-1 text-muted-foreground">
            <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" />
            {selectedGroup.meeting_venue || venue}
          </p>
        </div>
      )}
      <div 
        className="space-y-2 text-sm text-gray-600 [&_a]:text-blue-600 [&_a]:underline [&_a]:hover:text-blue-800 whitespace-pre-wrap"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(agenda) }}
      />
    </div>
  );
};

export default EventAgenda;